import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface BottomSheetProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}
export function BottomSheet({
  open,
  title,
  onClose,
  children
}: BottomSheetProps) {
  const reduceMotion = useReducedMotion();
  const panelRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    panelRef.current?.focus();
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-17" data-mp="2mtw4ld3hcw9c">
      {open && <div className="fixed inset-0 z-50 flex items-end justify-center" data-id="element-18" data-mp="74b9r02w8nbm">
          <motion.button type="button" aria-label="Close" onClick={onClose} className="absolute inset-0 bg-ink/25" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} data-id="element-19" data-mp="76e9ibtulutj" />
          <motion.div ref={panelRef} role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} initial={reduceMotion ? {
        opacity: 0
      } : {
        y: 24,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        y: 24,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-md rounded-t-3xl border border-line bg-surface px-5 pb-[max(1.25rem,env(safe-area-inset-bottom))] pt-5 outline-none sm:mb-6 sm:rounded-3xl" data-id="element-20" data-mp="1af63l7i2gxys">
            <div className="mb-4 flex items-center justify-between" data-id="element-21" data-mp="3v4vifkirsjrh">
              <h2 className="text-base font-semibold text-ink" data-id="element-22" data-mp="3zc2g59qdyc6">{title}</h2>
              <button type="button" onClick={onClose} aria-label={`Close ${title.toLowerCase()}`} className="flex h-11 w-11 items-center justify-center rounded-full text-muted transition-colors duration-150 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-23" data-mp="3x96z5pt7d02">
                <XIcon size={18} strokeWidth={1.75} data-id="element-24" data-mp="395g1jwfjnu7r" />
              </button>
            </div>
            {children}
          </motion.div>
        </div>}
    </AnimatePresence>;
}